﻿const allSelectors = document.querySelectorAll('[data-permission="all"]');

allSelectors.forEach((element, index, parent) => {
	element.addEventListener('change', function () {
		let id = this.id;
		let isChecked = this.checked;
		let others = document.querySelectorAll(`[data-permission="${id}"]`);
		others.forEach((item, index, parent) => {
			item.checked = isChecked;
		});
	});
});

const singleSelectors = document.querySelectorAll('[data-permission]:not([data-permission="all"]');
singleSelectors.forEach((element, index, parent) => {
	element.addEventListener('change', function () {
		let id = this.dataset.permission;
		let groupSelector = document.querySelector(`#${id}`);
		let groupSelectors = document.querySelectorAll(`[data-permission="${id}"]`);
		let allChecked = true;
		groupSelectors.forEach((item, index, parent) => {
			allChecked = allChecked && item.checked;
		});
		groupSelector.checked = allChecked;
	});
});

const roleSelect = document.querySelector('[data-roles]');
if (roleSelect) {
	roleSelect.addEventListener('change', function () {
		let allOptions = roleSelect.querySelectorAll('option');
		allOptions.forEach(option => {
			if (option.value) {
				let values = option.value.split(',');
				values.forEach(value => {
					let item = document.querySelector(`#${value}`);
					item.checked = option.selected;
				});
			}
		});
	});
}